import { FormattedMessage } from 'react-intl';

function SubscriptionPage() {

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "65vh", textAlign: "center", padding: "0 20px" }}>
            <h2 style={{ fontSize: "24px", fontWeight: 900, margin: 0 }}>
                <FormattedMessage id="subscription_page_title" />
            </h2>
            <p>
                <FormattedMessage id="subscription_page_description" />
            </p>
        </div>
    )
}

export default SubscriptionPage;
